function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M480,366.1l85.2-78.1c18.1-16.6,12.3-44.4-8.6-53.4L480,201.8V80c0-8.8-7.2-16-16-16h-48V24c0-13.3-10.7-24-24-24H248 c-13.3,0-24,10.7-24,24v40h-48c-8.8,0-16,7.2-16,16v121.8l-76.1,32.6c-22.5,9.6-26.4,37.8-9.6,53.2l85.6,78.5 C160,402.2,109,480,12,480c-6.6,0-12,5.4-12,12v8c0,6.6,5.4,12,12,12c65.5,0,117.3-29,150.8-73.1C173,480.8,210.9,512,256,512h128 c45.1,0,83-31.2,93.2-73.1C510.9,483.3,562.8,512,628,512c6.6,0,12-5.4,12-12v-8c0-6.6-5.4-12-12-12C534.4,480,480,405.2,480,366.1z  M256,32h128v32H256V32z M192,96h256v92l-115.4-49.5c-8-3.4-17.2-3.4-25.2,0L192,188V96z M448,352v64c0,35.3-28.7,64-64,64H256 c-35.3,0-64-28.7-64-64v-64l-96-88l224-96l224,96L448,352z"
});

const SvgShipToShip = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 640 512",
    style: {
      enableBackground: "new 0 0 640 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShipToShip, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ship-to-ship.e73048e8.svg";
export { ForwardRef as ReactComponent };